import { defineMessage } from 'react-intl';

export const errorCodes = {
    // General error codes
    'ERROR-GENERAL-0000': {
        code: 'ERROR-GENERAL-0000',
        message: defineMessage({
            id: 'ERROR-GENERAL-0000',
            defaultMessage: 'Shop account invalid',
        }),
    },
    'ERROR-SHOP_ACCOUNT-0001': {
        code: 'ERROR-SHOP_ACCOUNT-0001',
        message: defineMessage({
            id: 'ERROR-SHOP_ACCOUNT-0001',
            defaultMessage: 'Shop account not found',
        }),
    },
    'ERROR-EMPLOYEE-0001': {
        code: 'ERROR-EMPLOYEE-0001',
        message: defineMessage({
            id: 'ERROR-EMPLOYEE-0001',
            defaultMessage: 'Employee existed, please choose another.',
        }),
    },
    'ERROR-EMPLOYEE-0003': {
        code: 'ERROR-EMPLOYEE-0003',
        message: defineMessage({
            id: 'ERROR-EMPLOYEE-0003',
            defaultMessage: 'Employee not found.',
        }),
    },
    'ERROR-EMPLOYEE-0004': {
        code: 'ERROR-EMPLOYEE-0004',
        message: defineMessage({
            id: 'ERROR-EMPLOYEE-0004',
            defaultMessage: 'Password duplicate, please choose another.',
        }),
    },
    'ERROR-FOOD-0004': {
        code: 'ERROR-FOOD-0004',
        message: defineMessage({
            id: 'ERROR-FOOD-0004',
            defaultMessage: 'Restaurant not found',
        }),
    },
    'ERROR-FOOD-0005': {
        code: 'ERROR-FOOD-0005',
        message: defineMessage({
            id: 'ERROR-FOOD-0005',
            defaultMessage: 'Group food not found',
        }),
    },
    'ERROR-FOOD-0003': {
        code: 'ERROR-FOOD-0003',
        message: defineMessage({
            id: 'ERROR-FOOD-0003',
            defaultMessage: 'PLU cannot be null',
        }),
    },
    'ERROR-FOOD-0002': {
        code: 'ERROR-FOOD-0002',
        message: defineMessage({
            id: 'ERROR-FOOD-0002',
            defaultMessage: 'PLU in exist.',
        }),
    },
    'ERROR-FOOD-0001': {
        code: 'ERROR-FOOD-0001',
        message: defineMessage({
            id: 'ERROR-FOOD-0001',
            defaultMessage: 'Food not found.',
        }),
    },
    'ERROR-GROUP-FOOD-0001': {
        code: 'ERROR-GROUP-FOOD-0001',
        message: defineMessage({
            id: 'ERROR-GROUP-FOOD-0001',
            defaultMessage: 'Group food not found',
        }),
    },
    'ERROR-FOOD-CONDITION-0001': {
        code: 'ERROR-FOOD-CONDITION-0001',
        message: defineMessage({
            id: 'ERROR-FOOD-CONDITION-0001',
            defaultMessage: 'Name food condition existed.',
        }),
    },
    'ERROR-FOOD-CONDITION-0002': {
        code: 'ERROR-FOOD-CONDITION-0002',
        message: defineMessage({
            id: 'ERROR-FOOD-CONDITION-0002',
            defaultMessage: 'Food condition not found.',
        }),
    },
    'ERROR-AUTH-TOKEN-0002': {
        code: 'ERROR-AUTH-TOKEN-0002',
        message: defineMessage({
            id: 'ERROR-AUTH-TOKEN-0002',
            defaultMessage: 'Token not found',
        }),
    },
    'ERROR-AUTH-TOKEN-0001': {
        code: 'ERROR-AUTH-TOKEN-0001',
        message: defineMessage({
            id: 'ERROR-AUTH-TOKEN-0001',
            defaultMessage: 'Wrong shop',
        }),
    },

    'ERROR-CUSTOMER-0004': {
        code: 'ERROR-CUSTOMER-0004',
        message: defineMessage({
            id: 'ERROR-CUSTOMER-0004',
            defaultMessage: 'Customer not found',
        }),
    },
    'ERROR-SHOP_ACCOUNT-0002': {
        code: 'ERROR-SHOP_ACCOUNT-0002',
        message: defineMessage({
            id: 'ERROR-SHOP_ACCOUNT-0002',
            defaultMessage: 'Username is exist!',
        }),
    },
    'ERROR-SHOP_ACCOUNT-0000': {
        code: 'ERROR-SHOP_ACCOUNT-0000',
        message: defineMessage({
            id: 'ERROR-SHOP_ACCOUNT-0000',
            defaultMessage: 'Group doesnt exist!',
        }),
    },
    'ERROR-ACCOUNT-0001': {
        code: 'ERROR-ACCOUNT-0001',
        message: defineMessage({
            id: 'ERROR-ACCOUNT-0001',
            defaultMessage: 'Username is exist!',
        }),
    },
    'ERROR-GENERAL-0005': {
        code: 'ERROR-GENERAL-0005',
        message: defineMessage({
            id: 'ERROR-GENERAL-0005',
            defaultMessage: 'Account not found',
        }),
    },
    'ERROR-RESTAURANT-0002': {
        code: 'ERROR-RESTAURANT-0002',
        message: defineMessage({
            id: 'ERROR-RESTAURANT-0002',
            defaultMessage: 'Restaurant duplicate path',
        }),
    },
    'ERROR-RESTAURANT-0001': {
        code: 'ERROR-RESTAURANT-0001',
        message: defineMessage({
            id: 'ERROR-RESTAURANT-0001',
            defaultMessage: 'Restaurant not found',
        }),
    },
    "ERROR-DEVICE-005": {
        code: 'ERROR-DEVICE-005',
        message: defineMessage({
            id: 'ERROR-DEVICE-005',
            defaultMessage: 'Device ID already exists',
        }),
    },
    "ERROR-DEVICE-0005": {
        code: 'ERROR-DEVICE-0005',
        message: defineMessage({
            id: 'ERROR-DEVICE-0005',
            defaultMessage: 'This kind already has device',
        }),
    },
    "ERROR-DEVICE-0004": {
        code: 'ERROR-DEVICE-0004',
        message: defineMessage({
            id: 'ERROR-DEVICE-0004',
            defaultMessage: 'Device existed, please choose another.',
        }),
    },
    "ERROR-FOOD-0006": {
        code: 'ERROR-FOOD-0006',
        message: defineMessage({
            id: 'ERROR-FOOD-0006',
            defaultMessage: 'No valid food items exist in this food group.',
        }),
    },
    'ERROR-PRINTER-006': {
        code: 'ERROR-PRINTER-006',
        message: defineMessage({
            id: 'ERROR-PRINTER-006',
            defaultMessage: 'This restaurant already has a delivery printer',
        }),
    },
    'ERROR-DB-CONFIG-009': {
        code: 'ERROR-DB-CONFIG-009',
        message: defineMessage({
            id: 'ERROR-DB-CONFIG-009',
            defaultMessage: 'Server provider reached max tenant',
        }),
    },
};
